// [S-788a / E-HARNESS] The eval scorecard — GET /evals/scorecard (platform
// reach). A 404 is the honest "nothing published yet" state, surfaced as
// `notPublished` rather than an error so the screen can say what publishes one.
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import type { EvalScorecard } from "@csai/core";
import { ApiError, useApi } from "./api";

export type { EvalScorecard, ScorecardFlow, FlowOutcome } from "@csai/core";

export const EVALS_KEY = ["evals", "scorecard"] as const;

export type ScorecardState = { notPublished: true; message: string } | { notPublished: false; card: EvalScorecard };

export function useEvalScorecard(): UseQueryResult<ScorecardState, Error> {
  const api = useApi("admin");
  return useQuery({
    queryKey: EVALS_KEY,
    queryFn: async (): Promise<ScorecardState> => {
      try {
        const card = await api<EvalScorecard>("/evals/scorecard");
        return { notPublished: false, card };
      } catch (err) {
        if (err instanceof ApiError && err.status === 404) {
          const body = err.body as { message?: string } | undefined;
          return { notPublished: true, message: body?.message ?? "No eval scorecard published yet." };
        }
        throw err;
      }
    },
    staleTime: 60_000,
  });
}
